// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1IXjH","selects":"Documents_selects__1cwGZ"};